"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _canvasWM = _interopRequireDefault(require("./__canvasWM"));
var _vuex = require("vuex");
var _default = exports.default = {
  name: 'WaterMark',
  computed: (0, _vuex.mapGetters)(['userInfo']),
  mounted() {
    const {
      name = '',
      account = ''
    } = this.userInfo;
    if (name && account) {
      (0, _canvasWM.default)({
        // @ts-ignore
        container: this.$el,
        content: `${name}@云山快仓${account.substr(-4)}`,
        width: `${300 * 0.75}px`,
        height: `${220 * 0.75}px`
      });
    }
  },
  beforeDestroy() {}
};